import axios from "axios";
import { store } from 'store';

export default axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  headers: {
    "Content-type": "application/json",
    "Authorization": `Bearer ${store.getState().auth.user?.token}`
  }
});